import { BuildingTimer as TimerPresenter } from './presenter';
import { connect, getActiveQuiz, setQuizHasTimeLimit, setSessionTimeLimitInSecondsUi, setSessionTimeLimitInSecondsApi, screenreaderNotification } from '@instructure/quiz-core';
function mapStateToProps(state) {
  var activeQuiz = getActiveQuiz(state);
  return {
    hasTimeLimit: activeQuiz.getWorkingInstance().hasTimeLimit,
    sessionTimeLimitInSeconds: activeQuiz.getWorkingInstance().sessionTimeLimitInSeconds,
    activeQuizId: activeQuiz.id
  };
}
export var Timer = connect(mapStateToProps, {
  setQuizHasTimeLimit: setQuizHasTimeLimit,
  setSessionTimeLimitInSecondsUi: setSessionTimeLimitInSecondsUi,
  setSessionTimeLimitInSecondsApi: setSessionTimeLimitInSecondsApi,
  screenreaderNotification: screenreaderNotification
})(TimerPresenter);
export default Timer;